
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream/create/single",
      function () {
        return require("private-next-pages/stream/create/single.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream/create/single"])
      });
    }
  